module.exports = __webpack_public_path__ + "img/H1.fd934730.png";